import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Col, Row, Spinner } from "react-bootstrap";

import Tiptap from "../components/TipTap/TipTap";
import SideBar from "../components/SideBar/SideBar";
import BillTabs from "../components/BillTabs/BillTabs";

import {
  fetchBill,
  billsSelector,
  fetchBills,
  fetchDocument,
  saveDocumentState,
} from "../_redux/billsSlice";
import { FormattedMessage } from "react-intl";

interface ParamTypes {
  id: string;
  documentId?: string;
}

function DocumentPage() {
  const dispatch = useDispatch();
  const {
    fetchingCurrentDocumentInProgress,
    currentDocument,
    fetchingCurrentDocumentError,
  } = useSelector(billsSelector);
  const { id: billId, documentId } = useParams<ParamTypes>();

  useEffect(() => {
    dispatch(fetchDocument(billId, documentId));
    dispatch(fetchBill(billId));
    dispatch(fetchBills());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billId, documentId]);

  const handleSaveDocumentState = (payload: Object) => {
    dispatch(saveDocumentState(billId, documentId, payload));
  };

  if (fetchingCurrentDocumentInProgress) {
    return (
      <Spinner animation="grow" role="status">
        <span className="sr-only">
          <FormattedMessage id="ECOMMERCE.COMMON.LOADING" />
        </span>
      </Spinner>
    );
  }

  if (fetchingCurrentDocumentError)
    return <p>{fetchingCurrentDocumentError?.message}</p>;

  if (!currentDocument) return null;

  const currentProposals = currentDocument.proposals || [];

  return (
    <>
      <Row>
        <Col sm={2}>
          <SideBar />
        </Col>

        <Col sm={10}>
          <Row>
            <Col>
              <h1>{currentDocument.name}</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <BillTabs />

              <Tiptap
                doc={currentDocument}
                onSaveDocState={handleSaveDocumentState}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default DocumentPage;
